<template>
  <v-container class="mt-0 pl-0 pr-0">
    <v-toolbar
      v-if="widgetsData.title!==''"
      flat
      color="error"
      dark
    >
      <v-toolbar-title>{{ widgetsData.title }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs :vertical="widgetsData.isVertical" color="error" icons-and-text style="box-shadow: unset !important" :height="!widgetsData.isVertical ? '50px' : 'auto'" show-arrows>
      <v-tab v-for="tab in widgetsData.tab" :key="tab.title+'Main'" :class="'tabCustom' + tab.activeColor+' text-left'" :active-class="'activeTab' + tab.activeColor"
             :style="tab.imageIcon!=='' ? customPadding : ''" @click="resetForm" dark>
        <v-img v-if="tab.imageIcon!==''" :src="imageBaseUrl+tab.imageIcon" contain width="25px" height="25px"
               class="ml-2 float-right" style="position: absolute;right: 6px"/>
        {{ tab.title }}
      </v-tab>

      <v-tab-item v-for="tabItem in widgetsData.tab" :key="tabItem.title+'Content'" >
        <v-card flat min-height="50vh" >
          <v-card-text class="mt-0 pl-0 pr-2">
            <page-render :class="'tabCustomContent' +tabItem.activeColor"
              ref="tabChild"
              :widgets="tabItem.widget"
              :editOrShowTarget="editOrShowTarget"
              :paramId="paramId"
              :requestApiUrl="requestApiUrl"
              @on-pagination="onPagination"
              @filter-page="filterPage"

            />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>

import axios from "@axios";
import {
  formConfig,
  initialSidebarsSize,
  tableDateHandler,
  tablePaginationHandler
} from "@/views/generator/page-handler";
import {mdiClose} from "@mdi/js";
import baseConfig from '@/../baseConfig'

export default {
  name: "n-tab-group",
  components: {PageRender: () => import('@/views/generator/page-render')},
  props: {
    // eslint-disable-next-line vue/require-default-prop
    state: String,
    id: String,
    widgets: Object,
    title: String,
    editOrShowTarget: String,
    paramId: String,
    requestApiUrl: String,
  },
  data() {
    return {
      OldIsVertical:'',
      activeTab: {
        backgroundColor: '#7056eb !important',
        color: 'white !important',
        borderRadius: '20px !important',
        marginRight: '10px',
      },
      customPadding: {
        paddingRight: "35px"
      },
      imageBaseUrl: baseConfig.basUrlRaw,
      stateData: this.state,
      widgetsData: this.widgets, // Initial value
      titleData: this.title, // Initial value
      pagination: [],
      paginationToQueryString: "?",
      deleteUrl: "",
    }
  },
  watch: {
    state(newValue) {
      this.stateData = newValue // Update when the prop changes
    },
    widgets(newValue) {
      this.widgetsData = newValue // Update when the prop changes
    },
    title(newValue) {
      this.titleData = newValue // Update when the prop changes
    }
  },
  mounted() {
    this.initing()
  },
  created() {
   // window.addEventListener("resize", this.myEventHandler);

  },
  destroyed() {
   // window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler(e) {
      if(window.innerWidth<600){
        if (this.OldIsVertical==='')
          this.OldIsVertical = this.widgetsData.isVertical
        this.widgetsData.isVertical = false
      }else {
        this.widgetsData.isVertical = this.OldIsVertical
      }
    },
    filterPage(r) {
      r.content.widget.map(w => {
        if (w.type === 'tabGroup') {
          w.data.tab.map(wdt => {
            wdt.widget = tableDateHandler(wdt.widget)
            wdt.widget = formConfig(wdt.widget)
          })
        }
      })
      //this.widgetsData.tab.map(wdt => wdt.widget = tableDateHandler(wdt.widget))
      this.$emit('filter-page', r)
    },
    onPagination(name, current, filter) {
      console.log('on tab page ran',name, current)
      this.$emit('on-pagination', name, current, filter)
    },
    //dynamic ddl from request here
    initing() {
      // eslint-disable-next-line no-param-reassign,no-return-assign
      this.widgetsData.tab.map(wdt => wdt.widget = formConfig(wdt.widget))
      // eslint-disable-next-line no-param-reassign,no-return-assign
      this.widgetsData.tab.map(wdt => wdt.widget = tableDateHandler(wdt.widget))
    },
    resetForm() {
      this.widgetsData.tab.map(wdt => {
        // eslint-disable-next-line no-return-assign
        // wdt.widget.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.type === 'text' || e.type === 'dropdown' || e.type === 'textarea' || e.type === 'radiobutton' || e.type === 'date' || e.type === 'time' ? e.model = '' : null)) : null))

        this.widgetsData.tab.map(wdt => wdt.widget = formConfig(wdt.widget))
        this.$refs.tabChild.map(tc => {
          if (typeof tc.$refs.childForm !== 'undefined')
            tc.$refs.childForm.map(cf => {
              Object.keys(cf.$refs).map(k => cf.$refs[k].resetValidation())
            })
        })
      })
    }
  }
}
</script>

<style>
.v-dialog--active {
  overflow: visible !important;
}

.v-tabs-slider-wrapper {
  display: none;
}
.activeTabPrimary {
  background-color: #9155fd  !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomPrimary {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #9155fd ;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentPrimary {
  border: 2px solid #9155fd ;
  border-radius: 25px;
}


.activeTabPurple {
  background-color: #9C2776 !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomPurple {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #9C2776;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentPurple {
  border: 2px solid #9C2776;
  border-radius: 25px;
}
.activeTabBlue {
  background-color: #1e3799 !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomBlue {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #1e3799;
  font-size: 12px !important;
  padding-left: 10px !important;
}

.tabCustomContentBlue {
  border: 2px solid #1e3799;
  border-radius: 25px;
}
.activeTabGreen {
  background-color: #2dae33 !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomGreen {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #2dae33;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentGreen {
  border: 2px solid #2dae33;
  border-radius: 25px;
}
.activeTabLightBlue {
  background-color: #2e9fff !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomLightBlue {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #2e9fff;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentLightBlue {
  border: 2px solid #2e9fff;
  border-radius: 25px;
}
.activeTabYellow {
  background-color: #fbc531 !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomYellow {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #fbc531;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentYellow {
  border: 2px solid #fbc531;
  border-radius: 25px;
}
.activeTabBlack {
  background-color: #292929 !important;
  color: white !important;
  border-radius: 20px !important;
  margin-right: 10px;
}
.tabCustomBlack {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-right: 10px;
  height: 47px !important;
  border-radius: 20px !important;
  margin-bottom: 5px !important;
  border: 2px solid #292929;
  font-size: 12px !important;
  padding-left: 10px !important;
}
.tabCustomContentBlack {
  border: 2px solid #292929;
  border-radius: 25px;
}
.noTopPadding {
  padding: 0 24px !important;
}
.v-card__subtitle, .v-card__text, .v-card__title {
  padding: 17px 2px !important;
}
</style>
